import React from 'react';
import PropTypes from 'prop-types';

import postscribe from 'postscribe';

class livestreamComponent extends React.Component {
	constructor(props) {
		super(props);
		this.width = null;
		this.height = null;
		this.livestreamId = null;
	}

	componentWillMount() {
		this.width = window.innerWidth - 100;
		this.height = window.innerHeight - 100;
		this.livestreamId = 'feed-embed-stand-alone';
		this.cleanOld();
	}

	componentDidMount() {
		let js_id = "js_" + this.livestreamId;

		postscribe( document.getElementsByTagName('body')[0],
			`<script type="text/javascript" id=${ js_id } data-embed_id=${ this.livestreamId } src="//livestream.com/assets/plugins/referrer_tracking.js"></script>`,
			{
				done: function() {
					topifyConsole.log( 'loading livestream referrer_tracking' );
				},
				error: function() {
					topifyConsole.warn( 'error loading: livestream referrer_tracking');
				}
			}
		);
	}

	componentWillUnmount() {
		this.cleanOld();
	}

	cleanOld() {
		let element = document.getElementById(`js_${ this.livestreamId }`);
		if( element ) {
			element.parentNode.removeChild( element );
			topifyConsole.log( "cleaning livestream referrer_tracking" );
		}
	}

	getUrl() {
		return `//livestream.com/accounts/${ this.props.content }/feed_embed?width=${ this.width }&height=${ this.height }`;
	}

	render() {
		let url = this.getUrl();

		return <iframe
				src={ url }
				width={ this.width } height={ this.height }
				frameBorder="0"
				id={ this.livestreamId }
				scrolling="auto" allowFullScreen />;
	}
}

livestreamComponent.propTypes = {
	content: PropTypes.string.isRequired
};

export default livestreamComponent;


// WEBPACK FOOTER //
// ./src/components/posts/livestreamComponent.js